import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import getColor from "@insite/mobius/utilities/getColor";

productDescriptionStyles.productDetailLink = mergeToNew(productDescriptionStyles.productDetailLink, {
    css: css`
        width: 100%;
    `,
    typographyProps: {
        weight: 700,
        css: css`
            width: 100%;
            ${wrapInContainerStyles}
            font-size: 16px;
            color: ${getColor("text.accent")} !important;
        `,
    },
});
